export const getPedido = ({ pedido }) => pedido;

export const getPedidos = ({ pedidos }) => pedidos;
